<div class="card flex justify-center">
  <p-togglebutton [(ngModel)]="isDarkMode" onLabel="Dark Mode On" offLabel="Dark Mode Off" (onChange)="toggleDarkMode()" />
</div>


<p>App Version: {{frontendVersion}}</p>
<p>Backend Version: {{backendVersion}}</p>
